<template>
    <div class="divcontent">
        <div class="content">
            <div class="item" @click="service">
                <i class="iconfont icon-kefu"></i>
                <span>专属客服</span>
            </div>
            <div class="item" @click="routLinkTo('/userCenter')">
                <i class="iconfont icon-31wode"></i>
                <span>我的</span>
            </div>
            <div class="item" @click="routLinkTo('/cart/shoppingCart')">
                <i class="iconfont icon-yihangyige4"></i>
                <span>购物车</span>
            </div>
            <div class="item" @click="showEWM">
                <i class="iconfont icon-erweima"></i>
                <span>二维码</span>
            </div>
        </div>
        <el-dialog width="380px" title="关注格瑞德公众号" :visible.sync="outerVisible">
            <img src="../../../static/graderweima.jpg">
        </el-dialog>
    </div>
</template>
<script name='service'>
export default {
    name: "TopTypeNav",
    props: {
        obj: Object,
    },
    data() {
        return {
            activeRoute: "/indexpage/index",
            searchKeyWord: "",
            outerVisible:false
        };
    },
    methods: {
        showEWM(){
            this.outerVisible = !this.outerVisible
        },
        routLinkTo(val) {
            if (val === '/quickly') {
                this.$router.push(val)
            } else {
                this.$router.push(val)
            }
        },
        service() {
            this.$message('客服暂未开通');
        }
    }
}
</script>
<style scoped lang='less'>
/* scoped 使用得定义的样式只在本页面内生效  */
.divcontent{
    position: relative;
    .showerm {
        position: fixed;
        width: 260px;
        height: 260px;
        top: 50%;
        left: 50%;
        z-index: 9999;
        img{
            width: 100%;
            height: 100%;
        }
    }
}
.content {
    position: fixed;
    top: 50%;
    right: 0;
    transform: translate(0, -50%);
    width: 70px;
    height: auto;
    background-color: #fff;
    box-shadow: 0 0 10px 0 rgba(0, 0, 0, .2);
    border-radius: 5px;

    .item {
        box-sizing: border-box;
        width: 100%;
        height: 70px;
        padding: 10px;
        text-align: center;
        border-bottom: 1px solid #efefef;
        cursor: pointer;

        &:hover {
            background-color: #F74747;

            i {
                color: #fff;
            }

            span {
                color: #fff;
            }
        }

        i {
            display: block;
            font-size: 30px;
            width: 100%;
        }

        span {
            display: block;
            font-size: 12px;
            color: #333;
            padding: 10px 0 0;
        }
    }

}
</style>
 


// WEBPACK FOOTER //
// src/components/base/Service.vue